import { useTranslation } from "react-i18next";
import LegalLayout from "./LegalLayout";

function FrContent() {
  return (
    <>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Éditeur du site</h2>
        <p>
          Le site <strong>Cartonomie</strong> (accessible aux adresses{" "}
          <a href="https://cartonomie.fr" className="text-[#E11D48] underline">cartonomie.fr</a> et{" "}
          <a href="https://cartonomie.com" className="text-[#E11D48] underline">cartonomie.com</a>) est édité à titre individuel par son propriétaire.
        </p>
        <p>
          Pour toute demande, vous pouvez nous joindre via la page{" "}
          <a href="/contact" className="text-[#E11D48] underline">Contact</a> ou par e‑mail à{" "}
          <a href="mailto:contact@cartonomie.fr" className="text-[#E11D48] underline">contact@cartonomie.fr</a>.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Directeur de la publication</h2>
        <p>
          Le directeur de la publication est le propriétaire du site Cartonomie. Les coordonnées complètes
          de l'éditeur sont communiquées sur simple demande adressée à{" "}
          <a href="mailto:contact@cartonomie.fr" className="text-[#E11D48] underline">contact@cartonomie.fr</a>,
          conformément à l'article 6-III-2 de la LCEN.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Hébergement</h2>
        <p>
          Le site Cartonomie est hébergé via la plateforme <strong>Emergent</strong> (Emergent Labs).{" "}
          Les données sont stockées sur une infrastructure cloud sécurisée.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Propriété intellectuelle</h2>
        <p>
          L'ensemble du site (charte graphique, code, textes, base de données indexée) est la propriété
          exclusive de Cartonomie, sauf mention contraire. Toute reproduction, représentation ou diffusion
          totale ou partielle est interdite sans autorisation préalable écrite.
        </p>
        <p>
          <strong>Pokémon</strong>, les noms des cartes, illustrations, marques et logos associés sont la
          propriété de <em>Nintendo, Creatures Inc., GAME FREAK Inc., The Pokémon Company</em> et{" "}
          <em>Wizards of the Coast</em>. Cartonomie est un service d'indexation de prix communautaire
          indépendant, sans affiliation officielle avec ces ayants droit. Les illustrations et noms de
          cartes sont utilisés à des fins d'identification dans le cadre du droit à l'information et de
          l'usage loyal (fair use / DSM Directive 2019/790, article 17).
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Données affichées</h2>
        <p>
          Les prix affichés sur Cartonomie proviennent d'agrégations de ventes réelles (eBay, Cardmarket,
          TCGPlayer, Mercari) et de contributions communautaires. Ils sont fournis à titre indicatif et
          ne constituent en aucun cas une offre commerciale ni un conseil en investissement.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Limitation de responsabilité</h2>
        <p>
          Cartonomie s'efforce de maintenir des données aussi exactes que possible mais ne saurait être
          tenu responsable d'erreurs, d'omissions ou des conséquences résultant de l'utilisation des
          informations diffusées. L'utilisateur reste seul responsable de ses décisions d'achat ou de vente.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Loi applicable</h2>
        <p>
          Les présentes mentions légales sont régies par la loi française. Tout litige relatif au site sera
          soumis à la compétence exclusive des tribunaux français.
        </p>
      </section>
    </>
  );
}

function EnContent() {
  return (
    <>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Site editor</h2>
        <p>
          <strong>Cartonomie</strong> (cartonomie.fr & cartonomie.com) is operated by its individual owner.
          Contact: <a href="mailto:contact@cartonomie.fr" className="text-[#E11D48] underline">contact@cartonomie.fr</a>.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Hosting</h2>
        <p>Cartonomie is hosted on the Emergent platform (Emergent Labs).</p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Intellectual property</h2>
        <p>
          The site (design, code, indexed database) is the exclusive property of Cartonomie unless stated
          otherwise. <strong>Pokémon</strong>, card names, illustrations and associated marks are the property
          of Nintendo, Creatures Inc., GAME FREAK Inc., The Pokémon Company and Wizards of the Coast.
          Cartonomie is an independent community price index with no official affiliation.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Displayed data</h2>
        <p>
          Prices shown on Cartonomie aggregate real-world sales (eBay, Cardmarket, TCGPlayer, Mercari) and
          community contributions. They are indicative only and do not constitute a commercial offer or
          investment advice.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-base text-slate-900">Liability</h2>
        <p>
          Cartonomie strives for accuracy but cannot be held liable for errors, omissions or any
          consequences arising from the use of the information published.
        </p>
      </section>
    </>
  );
}

export default function LegalNotice() {
  const { i18n } = useTranslation();
  const isFr = (i18n.language || "en").toLowerCase().startsWith("fr");
  return (
    <LegalLayout
      testId="legal-notice-page"
      title={isFr ? "Mentions légales" : "Legal notice"}
      subtitle={isFr
        ? "Informations légales sur l'éditeur et l'hébergeur du site Cartonomie."
        : "Legal information about the publisher and host of Cartonomie."}
      lastUpdated={isFr ? "Mise à jour · Février 2026" : "Updated · February 2026"}
    >
      {isFr ? <FrContent /> : <EnContent />}
    </LegalLayout>
  );
}
